import { resetFilterRequest } from '../api/filter.js';
import { getFilterSettings } from '../filter-tree';
import { getStickyStatus } from '../filter-tree/sticky';
import { getUrlScheme, scrollToTop, setQueryParamHistory } from '../utils/index.js';

/**
 * @type {import('./index.d').handleSort}
 */
export function handleSort(context, target, originalEvent = null) {
  const [getSort, setSort] = context.useContextState('sort', {
    isShow: false,
    sort: null,
  });

  const isValue = target.classList.contains('boost-sd__sorting-value');
  const isButton = target.classList.contains('boost-sd__sorting-button');
  const isOption = target.classList.contains('boost-sd__sorting-option');

  if (isOption) {
    if (originalEvent) originalEvent.stopPropagation();

    const sort = target.getAttribute('data-value');
    const { isShortenUrlParam } = getFilterSettings(context);

    if (getSort().sort !== sort || getSort().isShow !== false) {
      setSort({ sort, isShow: false });
      setQueryParamHistory('sort', sort, false, {
        isShortenUrlParam,
        urlScheme: getUrlScheme(),
      });
      resetFilterRequest(context);
    }
    const stickyStatus = getStickyStatus(context);
    if (stickyStatus.stickyEnabled) {
      scrollToTop({ behavior: 'auto' });
    }
    return;
  }

  // Toggle dropdown(childElementsList) on button/value click
  if (isValue || isButton) {
    const { isShow, sort } = getSort();
    setSort({ sort, isShow: !isShow });
  }

  context.render(() => {
    const sort = getSort();
    const childElementsList = context.document.querySelector('.boost-sd__sorting-list');
    const childElementsButton = context.document.querySelector('.boost-sd__sorting-button');

    if (!childElementsList || !childElementsButton) return;

    const isActive = childElementsList.classList.contains('boost-sd__sorting-list--active');

    if (sort?.isShow && !isActive) {
      childElementsList.classList.add('boost-sd__sorting-list--active');
      childElementsButton.classList.add('boost-sd__sorting-button--active');
      childElementsButton.setAttribute('aria-expanded', 'true');

      // Attach Escape key listener
      context.document.addEventListener('keydown', handleEscapeKey);
    } else if (!sort?.isShow && isActive) {
      childElementsList.classList.remove('boost-sd__sorting-list--active');
      childElementsButton.classList.remove('boost-sd__sorting-button--active');
      childElementsButton.setAttribute('aria-expanded', 'false');

      // Remove Escape key listener
      context.document.removeEventListener('keydown', handleEscapeKey);
    }

    // Attach click handlers to each option
    childElementsList.querySelectorAll('.boost-sd__sorting-option').forEach((option) => {
      option.addEventListener('click', (e) => {
        handleSort(context, option, e);
      });
    });

    function handleEscapeKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        const [getSort, setSort] = context.useContextState('sort');
        const sort = getSort();
        if (sort?.isShow) {
          setSort({ sort: sort.sort, isShow: false });
          childElementsList.classList.remove('boost-sd__sorting-list--active');
          childElementsButton.classList.remove('boost-sd__sorting-button--active');
          childElementsButton.setAttribute('aria-expanded', 'false');
          childElementsButton.focus();
        }
        context.document.removeEventListener('keydown', handleEscapeKey);
      }
    }
  }, ['sort']);
}

/**
 * @type {import('./index.d').handleClickOutsideSort}
 */
export const handleClickOutsideSort = (context, target) => {
  const sortingList = context.$('.boost-sd__sorting-list');

  if (sortingList) {
    if (!target?.closest('.boost-sd__sorting-button')) {
      const [getSort, setSort] = context.useContextState('sort');

      const sort = getSort();

      if (sort?.isShow) {
        setSort({
          isShow: false,
        });
      }
    }
  }
};
